import React, { useMemo } from 'react';
import Loading from '../../components/globales/Loading';
import TablaLayout from '../../components/globales/TablaLayout';
import ModalDynamic from '../../components/globales/ModalDynamic';
import useCrud from '../../hooks/useCrud';
import ENDPOINTS from '../../api/endpoints';
import { temaSchema } from '../../services/validators';

export default function Temas() {
    const keyField = 'id';

    const temasEndpoints = useMemo(() => ({
        listar: ENDPOINTS.encuestasTemas.listar,
        crear: ENDPOINTS.encuestasTemas.crear,
        actualizar: ENDPOINTS.encuestasTemas.actualizar,
        borrar: ENDPOINTS.encuestasTemas.borrar
    }), []);

    const initForm = () => ({
        nombre: '',
        descripcion: ''
    });

    const columns = [
        { label: 'No', key: 'index', align: 'center', render: (_, i) => i + 1 },
        { label: 'Nombre', key: 'nombre', width: '40%' },
        { label: 'Descripción', key: 'descripcion', width: '50%' }
    ];

    const {
        data,
        loading,
        error,
        showModal,
        actionType,
        formData,
        errors,
        openModal,
        closeModal,
        handleChange,
        submit,
        remove
    } = useCrud(temasEndpoints, { keyField, initForm, columns, schema: temaSchema });

    if (loading) return <Loading mensaje="Cargando Temas..." />;
    if (error) return <div className="text-danger">Error: {error.message}</div>;

    return (
        <div className="container">
            <TablaLayout
                title="Temas"
                data={data}
                columns={columns}
                keyField={keyField}
                onCreate={() => openModal('crear')}
                onView={item => openModal('consultar', item)}
                onEdit={item => openModal('editar', item)}
                onDelete={remove}
                disableDelete={item => item.registros_preguntas > 0}
            />

            <ModalDynamic
                show={showModal}
                accion={actionType}
                title="Tema"
                columns={columns}
                formData={formData}
                errors={errors}
                onChange={handleChange}
                onSubmit={submit}
                onClose={closeModal}
            />
        </div>
    );
}
